import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import toast from "react-hot-toast";

const CartSection = () => {
  const [cartItems, setCartItems] = useState([]);

  // ✅ Load cart from sessionStorage
  useEffect(() => {
    const savedCart = JSON.parse(sessionStorage.getItem("cart")) || [];
    setCartItems(savedCart);
  }, []);

  // ✅ Remove item from cart
  const handleRemove = (id) => {
    const updatedCart = cartItems.filter((item) => item.id !== id);
    setCartItems(updatedCart);
    sessionStorage.setItem("cart", JSON.stringify(updatedCart));
    toast.success("Product removed from cart");
  };

  // ✅ Calculate totals
  const subtotal = cartItems.reduce(
    (acc, item) => acc + parseFloat(item.price || 0) * (item.quantity || 1),
    0
  );
  const estimatedTax = subtotal > 0 ? 10 : 0;
  const total = subtotal + estimatedTax;

  // ✅ Random tags generator
  const generateTags = (productName) => {
    const words = productName.split(" ");
    const tagSamples = [
      "Printer",
      "Office",
      "Ink",
      "Paper",
      "Laser",
      "Compact",
      "Wireless",
      "Eco",
      "HP",
      "Canon",
      "Smart",
    ];
    return Array.from(
      new Set([
        ...words.slice(0, 2),
        ...tagSamples.sort(() => 0.5 - Math.random()).slice(0, 2),
      ])
    );
  };

  return (
    <section className="cart py-80">
      <div className="container container-lg">
        <div className="text-center py-80">
          <h4>Your wishlist is empty 🛒</h4>
          <Link to="/shop" className="btn btn-main mt-16">
            Continue Shopping
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CartSection;
